var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { appStorage } from '../../app/storage';
import { Logger, Metrika /*, ApiOK*/ } from '../classes/index';
import { YandexGames } from './YandexGames';
import bridge from '@vkontakte/vk-bridge';
var log = Logger.get('SDK:DATA', true).log;
export var SYNC_STRATEGY;
(function (SYNC_STRATEGY) {
    SYNC_STRATEGY[SYNC_STRATEGY["MAX_INT"] = 0] = "MAX_INT";
    SYNC_STRATEGY[SYNC_STRATEGY["MIN_INT_WITHOUT_0"] = 1] = "MIN_INT_WITHOUT_0";
    SYNC_STRATEGY[SYNC_STRATEGY["TRUE"] = 2] = "TRUE";
    SYNC_STRATEGY[SYNC_STRATEGY["ARR_MAX_INT"] = 3] = "ARR_MAX_INT";
    // MIN_INT,
    // OR,
    // AND,
})(SYNC_STRATEGY || (SYNC_STRATEGY = {}));
export function get() {
    var _this = this;
    return new Promise(function (resolve) {
        if (FOR_VK) {
            bridge
                .send('VKWebAppStorageGet', { keys: Object.keys(appStorage.get()) })
                .then(function (data) {
                resolve(data.keys.reduce(function (acc, cur) {
                    if (cur.value !== '') {
                        acc[cur.key] = cur.value;
                    }
                    return acc;
                }, {}));
            })
                .catch(function (err) { return Metrika.logError(err); });
        }
        if (FOR_YANDEX) {
            YandexGames.getData()
                .then(function (data) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    log('YandexGames.getData:', data);
                    resolve(data);
                    return [2 /*return*/];
                });
            }); })
                .catch(function (err) { return Metrika.logError(err); });
        }
        if (FOR_OK) {
            setTimeout(function () { return resolve({}); }, 100);
            // TODO тут можно синхронизироваться с сервером
        }
    });
}
export function sync(keys) {
    var _this = this;
    return new Promise(function (resolve) {
        if (FOR_VK) {
            bridge
                .send('VKWebAppStorageGet', { keys: keys.map(function (k) { return k.name; }) })
                .then(function (data) {
                syncKeys(keys, data.keys);
                resolve();
            })
                .catch(function (err) { return Metrika.logError(err); });
        }
        if (FOR_YANDEX) {
            YandexGames.getData()
                .then(function (data) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            log('YandexGames.getData:', data);
                            data = Object.entries(data).map(function (_a) {
                                var key = _a[0], value = _a[1];
                                return ({ key: key, value: value });
                            });
                            return [4 /*yield*/, syncKeys(keys, data)];
                        case 1:
                            _a.sent();
                            resolve();
                            return [2 /*return*/];
                    }
                });
            }); })
                .catch(function (err) { return Metrika.logError(err); });
        }
        if (FOR_OK) {
            setTimeout(function () { return resolve(); }, 100);
            // TODO тут можно синхронизироваться с сервером
        }
    });
}
function syncKeys(keys, items) {
    return __awaiter(this, void 0, void 0, function () {
        var _loop_1, i;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _loop_1 = function (i) {
                        var _b, name_1, strategy, externalName, appValue, item, sdkValue, result, length_1, i_1, value1, value2;
                        var _c, _d, _e, _f;
                        return __generator(this, function (_g) {
                            switch (_g.label) {
                                case 0:
                                    _b = keys[i], name_1 = _b.name, strategy = _b.strategy, externalName = _b.externalName;
                                    externalName = externalName || name_1;
                                    appValue = appStorage.get()[name_1];
                                    item = items.find(function (_a) {
                                        var key = _a.key;
                                        return key === externalName;
                                    });
                                    if (!(item && item.value)) return [3 /*break*/, 17];
                                    sdkValue = JSON.parse(item.value);
                                    if (!(strategy === SYNC_STRATEGY.MAX_INT)) return [3 /*break*/, 4];
                                    sdkValue = Number(sdkValue) || 0;
                                    if (!(sdkValue > appValue)) return [3 /*break*/, 1];
                                    appStorage.upd((_c = {}, _c[name_1] = sdkValue, _c));
                                    return [3 /*break*/, 3];
                                case 1:
                                    if (!(sdkValue < appValue)) return [3 /*break*/, 3];
                                    return [4 /*yield*/, save(externalName, appValue)];
                                case 2:
                                    _g.sent();
                                    _g.label = 3;
                                case 3: return [3 /*break*/, 16];
                                case 4:
                                    if (!(strategy === SYNC_STRATEGY.MIN_INT_WITHOUT_0)) return [3 /*break*/, 8];
                                    sdkValue = Number(sdkValue) || 0;
                                    if (!(Math.min(sdkValue, appValue) > 0)) return [3 /*break*/, 7];
                                    if (!(sdkValue < appValue)) return [3 /*break*/, 5];
                                    appStorage.upd((_d = {}, _d[name_1] = sdkValue, _d));
                                    return [3 /*break*/, 7];
                                case 5:
                                    if (!(sdkValue > appValue)) return [3 /*break*/, 7];
                                    return [4 /*yield*/, save(externalName, appValue)];
                                case 6:
                                    _g.sent();
                                    _g.label = 7;
                                case 7: return [3 /*break*/, 16];
                                case 8:
                                    if (!(strategy === SYNC_STRATEGY.TRUE)) return [3 /*break*/, 12];
                                    sdkValue = sdkValue === 'true' || sdkValue === true;
                                    if (!(sdkValue === true && appValue === false)) return [3 /*break*/, 9];
                                    appStorage.upd((_e = {}, _e[name_1] = true, _e));
                                    return [3 /*break*/, 11];
                                case 9:
                                    if (!(sdkValue === false && appValue === true)) return [3 /*break*/, 11];
                                    return [4 /*yield*/, save(externalName, appValue)];
                                case 10:
                                    _g.sent();
                                    _g.label = 11;
                                case 11: return [3 /*break*/, 16];
                                case 12:
                                    if (!(strategy === SYNC_STRATEGY.ARR_MAX_INT)) return [3 /*break*/, 15];
                                    if (!(sdkValue !== JSON.stringify(appValue) && /^\[.*?\]$/.test(sdkValue))) return [3 /*break*/, 14];
                                    sdkValue = JSON.parse(sdkValue);
                                    result = [];
                                    length_1 = Math.max(sdkValue.length, appValue.length);
                                    for (i_1 = 0; i_1 < length_1; i_1++) {
                                        value1 = appValue[i_1] || 0;
                                        value2 = sdkValue[i_1] || 0;
                                        result[i_1] = Math.max(value1, value2);
                                    }
                                    appStorage.upd((_f = {}, _f[name_1] = result, _f));
                                    return [4 /*yield*/, save(externalName, result)];
                                case 13:
                                    _g.sent();
                                    DEVELOPMENT && log(JSON.stringify({ sdkValue: sdkValue, appValue: appValue, result: result }));
                                    _g.label = 14;
                                case 14: return [3 /*break*/, 16];
                                case 15:
                                    DEVELOPMENT && log("\u041D\u0435 \u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0430\u044F \u0441\u0442\u0440\u0430\u0442\u0435\u0433\u0438\u044F: ".concat(strategy, "."));
                                    _g.label = 16;
                                case 16: return [3 /*break*/, 19];
                                case 17: return [4 /*yield*/, save(externalName, appValue)];
                                case 18:
                                    _g.sent();
                                    _g.label = 19;
                                case 19: return [2 /*return*/];
                            }
                        });
                    };
                    i = 0;
                    _a.label = 1;
                case 1:
                    if (!(i < keys.length)) return [3 /*break*/, 4];
                    return [5 /*yield**/, _loop_1(i)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    i++;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function save(key, value) {
    return __awaiter(this, void 0, void 0, function () {
        var data, err_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (FOR_VK) {
                        bridge
                            .send('VKWebAppStorageSet', { key: key, value: JSON.stringify(value) })
                            // .then((res) => log('VKWebAppStorageSet:', res)) // TODO убрать после проверки
                            .catch(function (err) { return Metrika.logError(err); });
                    }
                    if (!FOR_YANDEX) return [3 /*break*/, 5];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, YandexGames.getData()];
                case 2:
                    data = _b.sent();
                    value = JSON.stringify(value);
                    if (data && data[key] && data[key] === value)
                        return [2 /*return*/];
                    data = __assign(__assign({}, data), (_a = {}, _a[key] = value, _a));
                    delete data.key;
                    delete data.value;
                    return [4 /*yield*/, YandexGames.setData(data, true)];
                case 3:
                    _b.sent();
                    return [3 /*break*/, 5];
                case 4:
                    err_1 = _b.sent();
                    Metrika.logError(err_1);
                    return [3 /*break*/, 5];
                case 5:
                    if (FOR_OK) {
                        // TODO....
                    }
                    return [2 /*return*/];
            }
        });
    });
}
